// server 的 timezoneOffset 慣例是「使用者時區相對 UTC 的分鐘數，東為正」（台北 +480），
// 與 Date#getTimezoneOffset()（西為正，台北 -480）方向相反，故取負號。
// 花費列表與各分析查詢共用同一份實作，確保所有月份分組的月界一致。
const getTimezoneOffset = () => -new Date().getTimezoneOffset();

export default getTimezoneOffset;
